export class TokenExpiredError extends Error {
    constructor(message?: string) {
        super(message)
        console.error(message)
        this.name = 'TokenExpiredError'
    }
}
